import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { jsx } from '@emotion/core';
import { createRef, PureComponent } from 'react';
import { CardCvvIcon } from '../CardIcons';
import { validateCardCvv } from './validations';
import { getCardTypeInfo } from '../cardUtils';
import { FloatingLabelInput } from '../../FloatingLabelInput';
import { CustomInputContainer } from '../../CustomInputContainer';
import { filterProps, hasOwnProp, isFunction, isString, safeNormalize, stripNonDigits } from '../../../../utils';
import { getInputContainerPadding, inputContainerStyles, inputStyles, wrapperStyles } from '../commonStyles';
import { rtlNumberOnlyStyles } from '../../commonStyles';
var PROPS_TO_FILTER = ['autoComplete', 'blurHandler', 'cardType', 'containerStyleOverrides', 'cvvLength', 'displayError', 'focusHandler', 'iconPosition', 'inputContainerStyleOverrides', 'inputStyleOverrides', 'maxLength', 'minLength', 'name', 'onAfterCardTypeChange', 'pattern', 'shouldMaskCvv', 'type', 'label'];

class CardCvv extends PureComponent {
  constructor() {
    super(...arguments);

    _defineProperty(this, "cardCvvRef", this.props.forwardedRef || createRef(this, 'cardCvvRef'));

    _defineProperty(this, "getLength", () => {
      var _getCardTypeInfo$code;

      if (hasOwnProp(this.props, 'cvvLength')) {
        return this.props.cvvLength;
      }

      return ((_getCardTypeInfo$code = getCardTypeInfo(this.props.cardType).code) === null || _getCardTypeInfo$code === void 0 ? void 0 : _getCardTypeInfo$code.size) || 3;
    });

    _defineProperty(this, "getLabel", () => {
      var _getCardTypeInfo$code2;

      if (hasOwnProp(this.props, 'label')) {
        return this.props.label;
      }

      return ((_getCardTypeInfo$code2 = getCardTypeInfo(this.props.cardType).code) === null || _getCardTypeInfo$code2 === void 0 ? void 0 : _getCardTypeInfo$code2.name) || 'CVV';
    });
  }

  componentDidUpdate(prevProps) {
    var {
      cardType: prevCardType,
      cvvLength: prevCvvLength
    } = prevProps;
    var {
      cardType,
      cvvLength,
      onAfterCardTypeChange,
      value
    } = this.props;

    if (!isFunction(onAfterCardTypeChange)) {
      return;
    }

    var isNewType = cardType !== prevCardType;
    var isNewCvvLength = cvvLength && prevCvvLength !== cvvLength;

    if (isNewType || isNewCvvLength) {
      var _cvvLength = this.getLength();

      var props = {
        maxLength: _cvvLength,
        minLength: _cvvLength,
        required: this.props.required
      };
      onAfterCardTypeChange({
        validation: validateCardCvv(value, {
          props
        })
      });
    }
  }

  render() {
    var {
      props
    } = this;
    var {
      ariaDescribedByContent,
      containerStyleOverrides,
      displayError,
      hasError,
      iconPosition,
      id,
      inputContainerStyleOverrides: customInputContainerStyleOverrides,
      inputStyleOverrides,
      shouldMaskCvv,
      isV2
    } = props;
    var filteredProps = filterProps(props, PROPS_TO_FILTER);
    var length = this.getLength();
    var hasIcon = isString(iconPosition);
    var ariaDescribedById = !hasError && !displayError ? "".concat(id, "-security-code-info") : "".concat(id, "-error");
    return jsx(CustomInputContainer, {
      blurHandler: props.blurHandler,
      containerStyleOverrides: containerStyleOverrides,
      displayError: {
        message: displayError,
        styling: displayError || hasError
      },
      error: props.error,
      focusHandler: props.focusHandler,
      inputContainerStyleOverrides: [getInputContainerPadding(iconPosition), customInputContainerStyleOverrides],
      inputId: id
    }, focusAndBlurHandler => jsx("div", {
      css: wrapperStyles
    }, jsx(FloatingLabelInput, _extends({}, filteredProps, {
      ariaDescribedBy: ariaDescribedById,
      autoComplete: "cc-csc",
      blurHandler: focusAndBlurHandler,
      containerStyleOverrides: inputContainerStyles,
      demaskFn: stripNonDigits,
      focusHandler: focusAndBlurHandler,
      forwardedRef: this.cardCvvRef,
      hasError: displayError || hasError,
      inputMode: "numeric",
      inputStyleOverrides: [inputStyles, rtlNumberOnlyStyles, inputStyleOverrides],
      label: this.getLabel(),
      maxLength: length,
      minLength: length,
      name: "cvv",
      pattern: "[0-9]{".concat(length, "}"),
      preprocessFn: safeNormalize,
      type: shouldMaskCvv ? 'password' : 'tel',
      validationFn: validateCardCvv
    })), hasIcon && jsx(CardCvvIcon, {
      ariaDescribedByContent: ariaDescribedByContent,
      ariaDescribedById: ariaDescribedById,
      cardType: props.cardType,
      isLeft: iconPosition === 'left',
      isV2: isV2,
      styleOverrides: props.cvvIconStyleOverrides
    })));
  }

}

_defineProperty(CardCvv, "defaultProps", {
  id: 'cardCvv',
  isV2: false,
  required: true
});

export { CardCvv };